import { HttpEngine } from 'base/auth_service';
import { getPosthogDistinctId } from 'base/posthog';
import { ServiceHttpError } from 'base/service_error';
import {
  getUserJwt,
  logOutWithoutReload,
} from '../../../library/src/modules/cookies';
import {
  authRouteToUrl,
  getCurrentLocationForRedirect,
  INVALID_AUTH_TOAST_ID,
  TOAST_ID_SEARCH_PARAM,
} from '../auth/routes';

export function createHttpService() {
  return new HttpEngine(
    () => getUserJwt() || '',
    getPosthogDistinctId,
    (error: ServiceHttpError) => {
      if (error.status !== 401 || error.detail !== 'Invalid token') {
        return; // We only care about Unauthorized responses
      }

      // Boot user to login page if are Unauthorized
      logOutWithoutReload();

      window.location.href =
        authRouteToUrl({
          path: 'login',
          context: {
            redirect: getCurrentLocationForRedirect(),
          },
        }) + `&${TOAST_ID_SEARCH_PARAM}=${INVALID_AUTH_TOAST_ID}`;
    },
  );
}
